// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"14":"7022d2499c55b020","112":"91ad95ac5c257a84","579":"b38818c9db8d331e"}[chunkId] + ".js";
};